export default __webpack_public_path__ + "static/media/1.ffe481f4.jpg";